
<template>
  <div class="app-wrapper">
    <div class="navbarDiv" :class="{'hidden': hidden}">
      <navbar />
    </div>
    <div class="tagsView" :class="{'hidden': hidden}">
      <tags-view />
    </div>
    <div class="leftMenuDiv" :class="{'hidden': hidden}">
      <LeftNavLayout />
    </div>
    <div class="maindiv" :class="{'hidden': hidden}">
      <transition
        name="fade-transform"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar/index.vue'
import LeftNavLayout from './LeftNavLayout/index.vue'
import TagsView from './TagsView/index.vue'

export default {
  name: 'Layout',
  components: {
    Navbar,
    LeftNavLayout,
    TagsView
  },
  computed: {
    hidden () {
      return this.$route.path === '/index/index' || this.$route.path === '/index' || this.$route.path === '/index/allNotice' || this.$route.path === '/index/DownloadCenter'
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }
  .navbarDiv {
    width:calc(100% - 300px);
    height:50px;
    overflow: hidden;
    position: fixed;
    z-index:20;
    right:0;
    &.hidden{
      width:calc(100% - 120px)
    }
  }
  .leftMenuDiv {
    height:100vh;
    position: fixed;
    overflow-y:hidden;
    z-index: 1;
    &.hidden {
      width:120px;
    }
  }
  .maindiv {
    // height: 100vh;
    min-height: 100%;
    width: 100%;
    // overflow-y: scroll;
    min-width: 1100px;
    box-sizing: border-box;
    background: #f0f2f5;
    padding:100px 0 0 300px;
    &.hidden {
      padding-left:130px
    }
  }
  .tagsView {
    width: calc(100% - 300px);
    margin-top: 50px;
    background: #fff;
    height: 34px;
    border-top: 1px solid #d8dce5;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
    overflow: hidden;
    position: fixed;
    z-index: 20;
    right: 0;
    &.hidden{
      width: calc(100% - 120px)
    }
  }
</style>
<style>
  .searchCard {
    margin-bottom:16px;
    border-radius: 4px;
  }
  .searchCard .el-card__body {
    padding-bottom:0
  }
  .tableCard {
    margin-bottom:20px;
    border-radius: 10px 10px 0px 0px;
  }
  .tableCard .el-card__body {
    padding:0
  }
</style>
